
// This overrides the publication modal to provide a checkbox to force
// depositors to comply with Prism's Deposit Agreement.
//
// Copyright (C) 2025 Northwestern University
//
// Prism is all rights reserved.

import React from "react";
import { PublishModal, SubmitReviewModal } from "@js/invenio_rdm_records";
import { parametrize } from "react-overridable";


function LegalDisclaimer() {
  return (
    <>
      <p>
        Your deposit will create a record in Prism, which consists of the metadata
        (information such as the title, creators, etc.) AND the associated files
        — if any — uploaded with your deposit.
      </p>
      <p>
        If you are the copyright owner of the deposit, by accepting this
        license you do not give up the copyright to your work, and you do not
        give up the right to submit the work to publishers or other repositories.
      </p>
      <p>
        Northwestern University and Galter Library bear no responsibility for
        the contents of the deposit. If, at any time, you learn that your
        acceptance of this deposit agreement is inaccurate, you must
        contact <a href='mailto:prism@northwestern.edu'>prism@northwestern.edu</a> immediately.
      </p>
    </>
  );
}

function LabelOfCheckbox() {
  return (
    <span>
      I confirm that I have read and that I agree to{' '}
      <a href='https://libguides.galter.northwestern.edu/prism/deposit-agreement' target='_blank'>
        Prism's deposit agreement <i class='external alternate icon'></i>
      </a>.
    </span>
  );
}

const parameters = {
  extraCheckboxes: [
    {
      fieldPath: "acceptPrismDepositAgreement",
      text: <LabelOfCheckbox />
    },
  ],
  afterContent: () => <LegalDisclaimer />,
};

export const PublishModalComponent = parametrize(PublishModal, parameters);
export const SubmitReviewModalComponent = parametrize(SubmitReviewModal, parameters);
